export const CONFIG = {
  APP_TITLE: import.meta.env.VITE_APP_TITLE || 'App',

  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'this-place',
  API_TOKEN_STORAGE_KEY: import.meta.env.VITE_API_TOKEN_STORAGE_KEY || '',
  RUNNING_IN_ENV: import.meta.env.VITE_RUNNING_IN_ENVIRONMENT || 'development',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || ''
}
